var sb = require('@sb/util')
import store from '@sb/store'

var ReleaseAnimation = require('./releaseAnimation.js')

const POPUP_MAX_HEIGHT = 400
const POPUP_HARD_MAX_HEIGHT = 500
const POPUP_MIN_HEIGHT = 0

export default {
	name: 'Rating',
	props: ['convoKey'],

	data () {
		return {
			hide: true,
			...store.bind(this, ['convoEventM']),
			ratingHeight: 0,
			overlayOpacity: 0.3,
			comment: '',
		}
	},

	watch: {
		show (show) {
			if (show) this.open()
			this.close()
		},
	},

	mounted () {
		store.onConvoEvent(this, ev => {
			var evconvokey = sb.convoKeyOfEv(ev)
			if (evconvokey !== this.convoKey) return
			if (this.shoudDisplay()) this.open()
		})

		this.mouseUp = e => this.onMouseUp(e)
		this.mouseMove = e => this.onMouseMove(e)
		this.mouseDown = e => this.onMouseDown(e)

		var $ratingHandle = this.$refs.handle
		$ratingHandle.addEventListener('mousedown', this.mouseDown, 0)
		$ratingHandle.addEventListener('touchstart', this.mouseDown, 0)

		window.addEventListener('mouseup', this.mouseUp, 0)
		window.addEventListener('touchend', this.mouseUp, 0)
		window.addEventListener('mousemove', this.mouseMove, 0)
		window.addEventListener('touchmove', this.mouseMove, 0)

		this.animation = new ReleaseAnimation({
			maxY: POPUP_MAX_HEIGHT,
			minY: POPUP_MIN_HEIGHT,
			duration: 150,
		})

		this.close()
		if (this.shoudDisplay()) this.open()
	},

	unmounted () {
		var $ratingHandle = this.$refs.handle
		$ratingHandle.removeEventListener('mousedown', this.mouseDown, 0)
		$ratingHandle.removeEventListener('touchstart', this.mouseDown, 0)

		window.removeEventListener('mouseup', this.mouseUp, 0)
		window.removeEventListener('touchend', this.mouseUp, 0)
		window.removeEventListener('mousemove', this.mouseMove, 0)
		window.removeEventListener('touchmove', this.mouseMove, 0)
	},

	render () {
		let cls = this.hide ? 'd-none' : ''
		return (
			<div class={cls}>
				<div class="rating--overlay" style={`opacity: ${this.overlayOpacity * 0.5} !important;`}></div>
				<div class="rating" ref="rating" style={`color:red; height: ${this.ratingHeight}px !important;`}>
					<div class="rating--handle" ref="handle">
						<div class="rating--thumb"></div>
					</div>
					<div class="rating--content">
						<div class="rating--heading">
							{this.$t('rating_title')}
							<div class="rating--close-btn" vOn:click={this.onCloseRating}></div>
						</div>
						<div class="rating--description">{this.$t('rating_description')}</div>
						<textarea ref="comment" type="text" class="rating--comment" vOn:change={this.onCommentChange} />

						<div class="rating-faces-container">
							<div class="rating-face-container" vOn:click={this.onRatingPoor}>
								<img src={require('../../assets/img/rating--poor.svg')} />
								<p class="rating-face--text">{this.$t('poor')}</p>
							</div>
							<div class="rating-face-container" vOn:click={this.onRatingAverage}>
								<img src={require('../../assets/img/rating--average.svg')} />
								<p class="rating-face--text">{this.$t('average')}</p>
							</div>
							<div class="rating-face-container" vOn:click={this.onRatingGreat}>
								<img src={require('../../assets/img/rating--great.svg')} />
								<p class="rating-face--text">{this.$t('great')}</p>
							</div>
						</div>
						<div class="rating-no-thanks" vOn:click={this.onCloseRating}>
							{this.$t('no_thanks')}
						</div>
					</div>
				</div>
			</div>
		)
	},

	methods: {
		onCommentChange (e) {
			this.comment = e.target.value
		},

		shoudDisplay () {
			var eventM = this.convoEventM[this.convoKey]

			var requested
			var rated
			var ended

			sb.map(eventM, ev => {
				if (sb.get(ev, 'type') === 'conversation_state_updated' && sb.get(ev, 'data.conversation.state') === 'ended') {
					ended = ev
				}
				if (sb.get(ev, 'type') === 'conversation_rating_requested') requested = ev
				if (sb.get(ev, 'type') === 'conversation_rated' && sb.get(ev, 'by.id') === store.user.id) rated = ev
			})

			if (rated) return false
			var auto = store.accountSetting.auto_request_rating && ended
			return requested || auto
		},

		onCloseRating () {
			this.$emit('rate', { no_rating: true, comment: this.comment })
			this.close()
		},

		onRatingPoor () {
			this.$emit('rate', { rating: 1, comment: this.comment })
			this.close()
		},

		onRatingAverage () {
			this.$emit('rate', { rating: 3, comment: this.comment })
			this.close()
		},

		onRatingGreat () {
			this.$emit('rate', { rating: 5, comment: this.comment })
			this.close()
		},

		open () {
			if (!this.hide) return
			this.hide = false
			setTimeout(() => {
				if (this.$refs.comment) this.$refs.comment.focus()
			}, 400)
			this.$refs.comment.value = ''
			var popupStyle = this.$refs.rating.currentStyle || window.getComputedStyle(this.$refs.rating)
			var h0 = parseFloat(popupStyle.height)
			this.animation.play(-20, h0, h => {
				this.ratingHeight = h
				this.overlayOpacity = Math.min(1, (h - POPUP_MIN_HEIGHT) / (POPUP_HARD_MAX_HEIGHT - POPUP_MIN_HEIGHT))
			})
		},
		close () {
			if (this.hide) return
			var popupStyle = this.$refs.rating.currentStyle || window.getComputedStyle(this.$refs.rating)
			var h0 = parseFloat(popupStyle.height)
			this.animation.play(20, h0, h => {
				this.ratingHeight = h
				this.overlayOpacity = Math.min(1, (h - POPUP_MIN_HEIGHT) / (POPUP_HARD_MAX_HEIGHT - POPUP_MIN_HEIGHT))
				if (h < POPUP_MIN_HEIGHT + 10) {
					if (!this.hide) {
						this.hide = true
					}
				}
			})
		},
		onMouseDown (e) {
			this.mousePushed = true
			this.animation.stop()
			e.preventDefault()
			if (e.touches && e.touches[0]) e = e.touches[0]
			this.mousePushedDy = e.pageY - window.pageYOffset - this.$refs.rating.getBoundingClientRect().y
		},

		onMouseUp (e) {
			if (!this.mousePushed) return
			if (e.touches && e.touches[0]) e = e.touches[0]
			this.mousePushed = false
			var popupStyle = this.$refs.rating.currentStyle || window.getComputedStyle(this.$refs.rating)
			var h0 = parseFloat(popupStyle.height)
			this.animation.play(this.mouseVelocity, h0, h => {
				this.ratingHeight = h
				this.overlayOpacity = Math.min(1, (h - POPUP_MIN_HEIGHT) / (POPUP_HARD_MAX_HEIGHT - POPUP_MIN_HEIGHT))
				if (h < POPUP_MIN_HEIGHT + 10) {
					if (!this.hide) {
						this.hide = true
						this.$emit('rate', { no_rating: true })
					}
				}
			})
		},

		onMouseMove (e) {
			if (!this.mousePushed) return
			if (e.touches && e.touches[0]) e = e.touches[0]
			var my = e.pageY

			this.mouseVelocity = my - this.lastMouseY
			this.lastMouseY = my
			my = my - this.mousePushedDy
			var K = 10000
			var height = this.$refs.rating.getBoundingClientRect().bottom - my

			if (height > POPUP_MAX_HEIGHT) {
				//TODO
				var beta = K / (POPUP_HARD_MAX_HEIGHT - POPUP_MAX_HEIGHT) - POPUP_MAX_HEIGHT

				height = POPUP_HARD_MAX_HEIGHT - K / (height + beta)
			}
			this.ratingHeight = height
			this.overlayOpacity = Math.min(1, (height - POPUP_MIN_HEIGHT) / (POPUP_HARD_MAX_HEIGHT - POPUP_MIN_HEIGHT))
		},
	},
}
